import { globalConstants } from '../constants';
import { apiService } from '../services';

export const globalActions = {
  startLoading,
  stopLoading,
  loadCourts,
  loadConfig
};

function startLoading() {
  return { type: globalConstants.START_LOADING };
}

function stopLoading() {
  return { type: globalConstants.STOP_LOADING };
}

function loadCourts() {
  return dispatch => {
    dispatch(request());

    apiService.loadCourts()
      .then(
        (res) => {
          dispatch(success(res));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: globalConstants.LOADCOURTS_REQUEST } }
  function success(res) { return { type: globalConstants.LOADCOURTS_SUCCESS, res } }
  function failure(error) { return { type: globalConstants.LOADCOURTS_FAILURE, error } }
}

function loadConfig() {
  return dispatch => {
    dispatch(request());

    apiService.loadConfig()
      .then(
        (res) => {
          dispatch(success(res));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: globalConstants.LOADCONFIG_REQUEST } }
  function success(res) { return { type: globalConstants.LOADCONFIG_SUCCESS, res } }
  function failure(error) { return { type: globalConstants.LOADCONFIG_FAILURE, error } }
}
